import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "../ui/elements/buttons/Button";
import { DialogContent } from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  subMessage?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  message = "Are you sure?",
  confirmText = "Yes",
  cancelText = "No",
  subMessage='',
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{message}</DialogTitle>
      <DialogContent>{subMessage}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {cancelText}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose(); // Optionally close after confirming
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
